mutation AttachUserProfileDocument($input: AttachUserProfileDocumentInput!) {
  attachUserProfileDocument(input: $input) {
    clientMutationId
    entityDocuments {
      id
      fileReference
    }
  }
}
